export const SELLER = {
  name: "ИП Табанакова Владлена Николаевна",
  shortName: "ИП Табанакова В.Н.",
  inn: "614006477488",
  ogrnip: "320619600051511",
  ogrnipIssued: "30 марта 2020 г.",
  address: "359030, Республика Калмыкия, Приютненский район, с. Приютное, ул. Лиманная, д. 35",
  bank: "Акционерное общество «ТБанк» (АО «ТБанк»)",
  account: "40802810900006112309",
  bik: "044525974",
  corrAccount: "30101810145250000974",
  bankAddress: "127287, г. Москва, ул. Хуторская 2-я, д. 38А, стр. 26",
  site: "tkanopolis.ru",
  siteUrl: "https://tkanopolis.ru/",
} as const;

export const COOKIE_CONSENT_NAME = "cookie_consent";
export const COOKIE_CONSENT_ACCEPTED = "accepted";
export const COOKIE_CONSENT_DECLINED = "declined";
